import authenticate from '@/middleware/authenticate'
import apiCompany from '@/api/administration/company'
import store from '@/store'

export default [
  {
    path: '/org-chart-levels',
    name: 'org-chart-level',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/org-chart-level'),
    props: route => ({ companies: route.params.companies }),
    beforeEnter: async (to, from, next) => {
      to.params.companies = (await apiCompany.get({
        params: { page: -1 },
        headers: {
          'X-PERMISSION-ALLOW-CODE': store.getters.permissionAllowCode
        }
      })).data
      next()
    }
  }
]
